import { render, staticRenderFns } from "./investments.vue?vue&type=template&id=f4a04c4a&scoped=true&"
import script from "./investments.vue?vue&type=script&lang=js&"
export * from "./investments.vue?vue&type=script&lang=js&"
import style0 from "./investments.vue?vue&type=style&index=0&id=f4a04c4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4a04c4a",
  null
  
)

export default component.exports